import { Injectable } from '@angular/core';

/**
static Data Listings
*/
@Injectable({
  providedIn: 'root',
})
export class FooterListingService {
  constructor() {}
  FooterListing_real_estate = [{"id":1,"name":"Abbeville Real Estate"},{"id":2,"name":"Alexandria Real Estate"},{"id":3,"name":"Baker Real Estate"},{"id":4,"name":"Baton Rouge Real Estate"},{"id":5,"name":"Bayou Blue Real Estate"},{"id":6,"name":"Bayou Cane Real Estate"},{"id":7,"name":"Belle Chasse Real Estate"},{"id":8,"name":"Bogalusa Real Estate"},{"id":9,"name":"Bossier City Real Estate"},{"id":10,"name":"Broussard Real Estate"},{"id":11,"name":"Central Real Estate"},{"id":12,"name":"Chalmette Real Estate"},{"id":13,"name":"Claiborne Real Estate"},{"id":14,"name":"Covington Real Estate"},{"id":15,"name":"Crowley Real Estate"},{"id":16,"name":"DeRidder Real Estate"},{"id":17,"name":"Destrehan Real Estate"},{"id":18,"name":"Estelle Real Estate"},{"id":19,"name":"Gardere Real Estate"},{"id":20,"name":"Gonzales Real Estate"},{"id":21,"name":"Gretna Real Estate"},{"id":22,"name":"Hammond Real Estate"},{"id":23,"name":"Harvey Real Estate"},{"id":24,"name":"Houma Real Estate"},{"id":25,"name":"Jefferson Real Estate"},{"id":26,"name":"Kenner Real Estate"},{"id":27,"name":"Lafayette Real Estate"},{"id":28,"name":"Lake Charles Real Estate"},{"id":29,"name":"Laplace Real Estate"},{"id":30,"name":"Luling Real Estate"},{"id":31,"name":"Mandeville Real Estate"},{"id":32,"name":"Marrero Real Estate"},{"id":33,"name":"Metairie Real Estate"},{"id":34,"name":"Minden Real Estate"},{"id":35,"name":"Monroe Real Estate"},{"id":36,"name":"Morgan City Real Estate"},{"id":37,"name":"Moss Bluff Real Estate"},{"id":38,"name":"Natchitoches Real Estate"},{"id":39,"name":"New Iberia Real Estate"},{"id":40,"name":"New Orleans Real Estate"},{"id":41,"name":"Opelousas Real Estate"},{"id":42,"name":"Pineville Real Estate"},{"id":43,"name":"Prairieville Real Estate"},{"id":44,"name":"Raceland Real Estate"},{"id":45,"name":"River Ridge Real Estate"},{"id":46,"name":"Ruston Real Estate"},{"id":47,"name":"Shenandoah Real Estate"},{"id":48,"name":"Shreveport Real Estate"},{"id":49,"name":"Slidell Real Estate"},{"id":50,"name":"Sulphur Real Estate"},{"id":51,"name":"Terrytown Real Estate"},{"id":52,"name":"Thibodaux Real Estate"},{"id":53,"name":"West Monroe Real Estate"},{"id":54,"name":"Woodmere Real Estate"},{"id":55,"name":"Youngsville Real Estate"}];
  FooterListing_rentals = [{"id":1,"name":"Abbeville Homes for Sale"},{"id":2,"name":"Alexandria Homes for Sale"},{"id":3,"name":"Baker Homes for Sale"},{"id":4,"name":"Baton Rouge Homes for Sale"},{"id":5,"name":"Bayou Blue Homes for Sale"},{"id":6,"name":"Bayou Cane Homes for Sale"},{"id":7,"name":"Belle Chasse Homes for Sale"},{"id":8,"name":"Bogalusa Homes for Sale"},{"id":9,"name":"Bossier City Homes for Sale"},{"id":10,"name":"Broussard Homes for Sale"},{"id":11,"name":"Central Homes for Sale"},{"id":12,"name":"Chalmette Homes for Sale"},{"id":13,"name":"Claiborne Homes for Sale"},{"id":14,"name":"Covington Homes for Sale"},{"id":15,"name":"Crowley Homes for Sale"},{"id":16,"name":"DeRidder Homes for Sale"},{"id":17,"name":"Destrehan Homes for Sale"},{"id":18,"name":"Estelle Homes for Sale"},{"id":19,"name":"Gardere Homes for Sale"},{"id":20,"name":"Gonzales Homes for Sale"},{"id":21,"name":"Gretna Homes for Sale"},{"id":22,"name":"Hammond Homes for Sale"},{"id":23,"name":"Harvey Homes for Sale"},{"id":24,"name":"Houma Homes for Sale"},{"id":25,"name":"Jefferson Homes for Sale"},{"id":26,"name":"Kenner Homes for Sale"},{"id":27,"name":"Lafayette Homes for Sale"},{"id":28,"name":"Lake Charles Homes for Sale"},{"id":29,"name":"Laplace Homes for Sale"},{"id":30,"name":"Luling Homes for Sale"},{"id":31,"name":"Mandeville Homes for Sale"},{"id":32,"name":"Marrero Homes for Sale"},{"id":33,"name":"Metairie Homes for Sale"},{"id":34,"name":"Minden Homes for Sale"},{"id":35,"name":"Monroe Homes for Sale"},{"id":36,"name":"Morgan City Homes for Sale"},{"id":37,"name":"Moss Bluff Homes for Sale"},{"id":38,"name":"Natchitoches Homes for Sale"},{"id":39,"name":"New Iberia Homes for Sale"},{"id":40,"name":"New Orleans Homes for Sale"},{"id":41,"name":"Opelousas Homes for Sale"},{"id":42,"name":"Pineville Homes for Sale"},{"id":43,"name":"Prairieville Homes for Sale"},{"id":44,"name":"Raceland Homes for Sale"},{"id":45,"name":"River Ridge Homes for Sale"},{"id":46,"name":"Ruston Homes for Sale"},{"id":47,"name":"Shenandoah Homes for Sale"},{"id":48,"name":"Shreveport Homes for Sale"},{"id":49,"name":"Slidell Homes for Sale"},{"id":50,"name":"Sulphur Homes for Sale"},{"id":51,"name":"Terrytown Homes for Sale"},{"id":52,"name":"Thibodaux Homes for Sale"},{"id":53,"name":"West Monroe Homes for Sale"},{"id":54,"name":"Woodmere Homes for Sale"},{"id":55,"name":"Youngsville Homes for Sale"}];
  FooterListing_mortage_rate = [
    {'id': '1', "name": "Louisiana",abbrev:"LA"},
    {"id": "2", "name": "Arizona",abbrev:"AZ"},
    {"id": "3", "name": "Texas",abbrev:"TX"},
    {"id": "4", "name": "New York",abbrev:"NY"},
    {"id": "5", "name": "California",abbrev: "CA"},
    {"id": '6', "name": "Mississippi",abbrev:"MS"},
    {"id": "7", "name": "Ohio",abbrev:"OH"},
    {"id": "8", "name": "Georgia",abbrev:"GA"},
    {"id": "9", "name": "North Carolina",abbrev:"NC"},
    {"id": "10", "name": "Michigan",abbrev:"MI"},
    {"id": "11", "name": "New Jersey",abbrev:"NJ"},
    {"id": "12", "name": "Virginia",abbrev:"VA"},
    {"id": "13", "name": "Washington",abbrev:"WA"},
    {"id": "14", "name": "Florida",abbrev:"FL"},
    {"id": "15", "name": "New Jersey",abbrev:"NJ"},
    {"id": "16", "name": "Tennessee",abbrev:"TN"},
    {"id": "17", "name": "Virginia",abbrev:"VA"},
    {"id": '18', "name": "Massachusetts",abbrev:"MA"},
    {"id": '19', "name": "Indiana",abbrev:"IN"},
    {"id": '20', "name": "Missouri",abbrev:"MO"},
    {"id": '21', "name": "Maryland",abbrev:"MD"},
    {"id": '22', "name": "Colorado",abbrev:"CO"},
    {"id": '23', "name": "Wisconsin",abbrev:"WI"},
    {"id": '24', "name": "Minnesota",abbrev:"MN"},
    {"id": '25', "name": "South Carolina",abbrev:"SC"},
    {"id": '26', "name": "Alabama",abbrev:"AL"},
    {"id": "27", "name": "Pennsylvania",abbrev:"PA"},
    {"id": '28', "name": "Kentucky",abbrev:"KY"},
    {"id": '29', "name": "Oregon",abbrev:"OR"},
    {"id": '30', "name": "Oklahoma",abbrev:"OK"},
    {"id": '31', "name": "Connecticut",abbrev:"CT"},
    {"id": '32', "name": "Utah",abbrev:"UT"},
    {"id": '33', "name": "Nevada",abbrev:"NV"},
    {"id": '34', "name": "Iowa",abbrev:"IA"},
    {"id": '35', "name": "Arkansas",abbrev:"AR"},
    {"id": "36", "name": "Illinois",abbrev:"IL"},
    {"id": '37', "name": "Kansas",abbrev:"KS"},
    {"id": '38', "name": "New Mexico",abbrev:"NM"},
    {"id": '39', "name": "Nebraska",abbrev:"NE"},
    {"id": '40', "name": "Idaho",abbrev:"ID"},
    {"id": '41', "name": "West Virginia",abbrev:"WV"},
    {"id": '42', "name": "Hawaii",abbrev:"HI"},
    {"id": '43', "name": "New Hampshire",abbrev:"NH"},
    {"id": '44', "name": "Maine",abbrev:"ME"},
    {"id": '45', "name": "Montana",abbrev:"MT"},
    {"id": '46', "name": "Rhode Island",abbrev:"RI"},
    {"id": '47', "name": "Delaware",abbrev:"DE"},
    {"id": '48', "name": "South Dakota",abbrev:"SD"},
    {"id": '49', "name": "North Dakota",abbrev:"ND"},
    {"id": '50', "name": "Alaska",abbrev:"AK"},
    {"id": '51', "name": "District of Columbia",abbrev:"DC"},
    {"id": '52', "name": "Vermont",abbrev:"VT"}
  ];
   states = [
    { name: 'Alabama', abbrev: 'AL' },
    { name: 'Alaska', abbrev: 'AK' },
    { name: 'Arizona', abbrev: 'AZ' },
    { name: 'Arkansas', abbrev: 'AR' },
    { name: 'California', abbrev: 'CA' },
    { name: 'Colorado', abbrev: 'CO' },
    { name: 'Connecticut', abbrev: 'CT' },
    { name: 'Delaware', abbrev: 'DE' },
    { name: 'Florida', abbrev: 'FL' },
    { name: 'Georgia', abbrev: 'GA' },
    { name: 'Hawaii', abbrev: 'HI' },
    { name: 'Idaho', abbrev: 'ID' },
    { name: 'Illinois', abbrev: 'IL' },
    { name: 'Indiana', abbrev: 'IN' },
    { name: 'Iowa', abbrev: 'IA' },
    { name: 'Kansas', abbrev: 'KS' },
    { name: 'Kentucky', abbrev: 'KY' },
    { name: 'Louisiana', abbrev: 'LA' },
    { name: 'Maine', abbrev: 'ME' },
    { name: 'Maryland', abbrev: 'MD' },
    { name: 'Massachusetts', abbrev: 'MA' },
    { name: 'Michigan', abbrev: 'MI' },
    { name: 'Minnesota', abbrev: 'MN' },
    { name: 'Mississippi', abbrev: 'MS' },
    { name: 'Missouri', abbrev: 'MO' },
    { name: 'Montana', abbrev: 'MT' },
    { name: 'Nebraska', abbrev: 'NE' },
    { name: 'Nevada', abbrev: 'NV' },
    { name: 'New Hampshire', abbrev: 'NH' },
    { name: 'New Jersey', abbrev: 'NJ' },
    { name: 'New Mexico', abbrev: 'NM' },
    { name: 'New York', abbrev: 'NY' },
    { name: 'North Carolina', abbrev: 'NC' },
    { name: 'North Dakota', abbrev: 'ND' },
    { name: 'Ohio', abbrev: 'OH' },
    { name: 'Oklahoma', abbrev: 'OK' },
    { name: 'Oregon', abbrev: 'OR' },
    { name: 'Pennsylvania', abbrev: 'PA' },
    { name: 'Rhode Island', abbrev: 'RI' },
    { name: 'South Carolina', abbrev: 'SC' },
    { name: 'South Dakota', abbrev: 'SD' },
    { name: 'Tennessee', abbrev: 'TN' },
    { name: 'Texas', abbrev: 'TX' },
    { name: 'Utah', abbrev: 'UT' },
    { name: 'Vermont', abbrev: 'VT' },
    { name: 'Virginia', abbrev: 'VA' },
    { name: 'Washington', abbrev: 'WA' },
    { name: 'West Virginia', abbrev: 'WV' },
    { name: 'Wisconsin', abbrev: 'WI' },
    { name: 'Wyoming', abbrev: 'WY' }
];
}